import Axios from "../../axios";
import { ApiResponse } from "../../apiResponse";

export function createTutorSanad(slotData: object): Promise<ApiResponse> {
  return Axios.post(`v1/tutors/sanads`, slotData);
}

export function listTutorSanads(): Promise<ApiResponse> {
  return Axios.get(`v1/tutors/sanads`);
}
